import { ONE_TIME_CHARGE_EXTRA_ITEMS } from "@/lib/constant";
import { extraTotalWithCountOnly, extraTotalWithRentalDays } from "@/helpers/totalExtraPrice";
import { CheckoutSidebarProps } from "@/features/CheckoutSidebar";

export function generateCheckoutJson({
  car,
  total,
  dropOff,
  pickUp,
  extras,
  rentalDays,
}: CheckoutSidebarProps) {
  const extraOneTimeChargeTotal = extraTotalWithCountOnly(
    extras.filter((e) => ONE_TIME_CHARGE_EXTRA_ITEMS.includes(e.extra_id))
  );
  const extraTimesRentalDaysTotal = extraTotalWithRentalDays(
    extras.filter((e) => !ONE_TIME_CHARGE_EXTRA_ITEMS.includes(e.extra_id)),
    rentalDays
  );
  const extraTotal = extraOneTimeChargeTotal + extraTimesRentalDaysTotal;

  return {
    car,
    total,
    pickUp,
    dropOff,
    extras,
    rentalDays,
    extraTotal,
  };
}